// Hindi (हिन्दी). Keys are the English source strings. Brand names stay English.
export const hi = {
  "Log in": "लॉग इन",
  "Log out": "लॉग आउट",
  "Admin": "एडमिन",
  "Continue": "जारी रखें",
  "Retry": "फिर कोशिश करें",
  "Back": "वापस",
  "Back to browse": "ब्राउज़ पर वापस",

  "Admin access.": "एडमिन एक्सेस।",
  "Email": "ईमेल",
  "Password": "पासवर्ड",
  "Logging in…": "लॉग इन हो रहा है…",
  "Not an admin?": "एडमिन नहीं हैं?",
  "Enter with your access code": "अपने एक्सेस कोड से प्रवेश करें",

  "Private preview. Your access code opens the loop.":
    "प्राइवेट प्रीव्यू। आपका एक्सेस कोड लूप खोलता है।",
  "Access code": "एक्सेस कोड",
  "Entering…": "प्रवेश हो रहा है…",
  "Enter Algorhythmic": "Algorhythmic में प्रवेश करें",
  "Your email": "आपका ईमेल",
  "Sending…": "भेजा जा रहा है…",
  "Request access": "एक्सेस का अनुरोध करें",
  "You're on the list.": "आप सूची में हैं।",
  "We'll get back to you soon with your access code at {{email}}.":
    "हम जल्द ही आपको {{email}} पर आपका एक्सेस कोड भेजेंगे।",
  "Back to sign in": "साइन इन पर वापस",
  "Don't have an access code?": "एक्सेस कोड नहीं है?",
  "Request access code": "एक्सेस कोड का अनुरोध करें",
  "Admin login": "एडमिन लॉगिन",
  "Could not reach the server. Check your connection and try again.":
    "सर्वर तक नहीं पहुँच सके। अपना कनेक्शन जाँचें और फिर कोशिश करें।",

  "Could not load your episodes. Check your connection, then retry.":
    "आपके एपिसोड लोड नहीं हो सके। कनेक्शन जाँचें, फिर दोबारा कोशिश करें।",
  "Resume episode": "एपिसोड फिर से शुरू करें",
  "Play": "चलाएँ",
  "More info": "अधिक जानकारी",
  "Continue watching": "देखना जारी रखें",

  "Could not load this series. Check your connection and try again.":
    "यह सीरीज़ लोड नहीं हो सकी। कनेक्शन जाँचें और फिर कोशिश करें।",
  "Season": "सीज़न",
  "Season 1": "सीज़न 1",
  "Paused at {{time}}": "{{time}} पर रुका",
  "Watched": "देखा गया",

  "Could not load this episode. Check your connection and try again.":
    "यह एपिसोड लोड नहीं हो सका। कनेक्शन जाँचें और फिर कोशिश करें।",
  "You paused at {{time}}. Pick up where you left off?":
    "आप {{time}} पर रुके थे। वहीं से आगे बढ़ें?",
  "Start from beginning": "शुरू से चलाएँ",

  "Quick check": "छोटा सा चेक",
  "Not that one. One more try.": "वह नहीं। एक बार और।",
  "Talk it through with Morse. Then try once more.":
    "Morse के साथ इसे समझें। फिर एक बार और कोशिश करें।",
  "Morse has finished. Try once more.": "Morse ने पूरा कर लिया। एक बार और कोशिश करें।",
  "Correct.": "सही।",
  "Not quite.": "बिल्कुल नहीं।",
  "Could not record your answer. Continue watching. This attempt won't count.":
    "आपका उत्तर दर्ज नहीं हो सका। देखते रहें। यह प्रयास नहीं गिना जाएगा।",

  "Playback speed": "प्लेबैक स्पीड",
  "Quality": "क्वालिटी",
  "Audio language": "ऑडियो भाषा",
  "Subtitles": "सबटाइटल",
  "Reset quizzes for this episode": "इस एपिसोड के क्विज़ रीसेट करें",
  "Normal": "सामान्य",
  "Off": "बंद",
  "More languages coming": "और भाषाएँ जल्द ही",
  "Original audio only": "केवल मूल ऑडियो",
  "No subtitles for this episode yet": "इस एपिसोड के लिए अभी कोई सबटाइटल नहीं",
  "This will make all quizzes in this episode appear again. Continue?":
    "इससे इस एपिसोड के सभी क्विज़ दोबारा दिखेंगे। जारी रखें?",
  "Cancel": "रद्द करें",

  "Language": "भाषा",

  "Try it": "आज़माएँ",
  "Check": "जाँचें",
  "Checking…": "जाँच हो रही है…",
  "Take your time": "आराम से सोचें",
  "Clear": "मिटाएँ",
  "Delete": "हटाएँ",
  "Show ladder": "सीढ़ी दिखाएँ",
  "Hide ladder": "सीढ़ी छिपाएँ",
  "remainder": "शेष",
  "Read the remainders from bottom to top.": "शेषफल नीचे से ऊपर पढ़ें।",
  "Convert": "बदलें",
  "Your answer": "आपका उत्तर",
  "Target": "लक्ष्य",
  "Yours": "आपका",
  "Red": "लाल",
  "Green": "हरा",
  "Blue": "नीला",
  "bits": "बिट",
  "Stretch task — no auto-grading yet.": "अतिरिक्त चुनौती — अभी ऑटो-जाँच नहीं है।",
  "Reveal solution": "हल दिखाएँ",
  "Hide solution": "हल छिपाएँ",
  "I finished this": "मैंने यह पूरा किया",
  "All practice": "सारा अभ्यास",
  "Now make it yours": "अब इसे अपना बनाएँ",
  "Four quick checks, then eight problems. Nothing is timed against you.":
    "चार छोटे चेक, फिर आठ सवाल। समय आपके ख़िलाफ़ नहीं चलता।",
  "Quick checks": "छोटे चेक",
  "Practice problems": "अभ्यास सवाल",
  "Watch the episode again": "एपिसोड दोबारा देखें",
  "Decimal": "दशमलव",
  "Tap the powers sitting under the ones.": "जिन अंकों के ऊपर 1 है, उनकी घातें दबाएँ।",
};
